import React, { useRef, useMemo } from 'react';
import JoditEditor from 'jodit-react';

const WelcomeMessageEditor = ({
  value = '',
  onChange,
  placeholder = 'Write a personalised welcome message for the new hire…',
  minHeight = 150,
  maxHeight = 220,
}) => {
  const editor = useRef(null);

  const config = useMemo(() => ({
    toolbar: true,
    placeholder,
    readonly: false,
    statusbar: false,
    showCharsCounter: false,
    showWordsCounter: false,
    minHeight,
    maxHeight,
    width: '100%',
    askBeforePasteFromWord: false,
    askBeforePasteHTML: false,
    defaultActionOnPaste: 'insert_clear_html',
    defaultActionOnPasteFromWord: 'insert_as_html',
    toolbarSticky: false,
    toolbarDisableStickyForMobile: false,
    removeButtons: ['eraser', 'fullsize', 'file', 'video', 'image', 'table', 'link'],
    sizeLG: 900,
    sizeMD: 700,
    sizeSM: 400,
    buttons: [
      'bold', 'italic', 'underline', '|',
      'ul', 'ol', '|',
      'font', 'fontsize', 'brush', '|',
      'left', 'center', 'right', 'justify', '|',
      'undo', 'redo',
    ],
    buttonsMD: [
      'bold', 'italic', 'underline', '|',
      'ul', 'ol', '|',
      'fontsize', 'brush', '|',
      'left', 'center', 'right', '|',
      'undo', 'redo',
    ],
    buttonsSM: [
      'bold', 'italic', 'underline', '|',
      'fontsize', '|',
      'left', 'center', 'right', '|',
      'undo', 'redo',
    ],
  }), [placeholder, minHeight, maxHeight]);

  return (
    <JoditEditor
      ref={editor}
      value={value}
      config={config}
      onChange={onChange}
    />
  );
};

export default WelcomeMessageEditor;
